import React, { useState } from 'react';
import LangToggle from '../components/LangToggle';
import { useLang, translations } from '../i18n';

const SIGNUP_URL = process.env.REACT_APP_SIGNUP_URL!;

const Signup: React.FC<{ onSuccess: () => void }> = ({ onSuccess }) => {
  const { lang } = useLang();
  const t = translations[lang];

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(SIGNUP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password })
      });
      const data = await res.json();
      if (data.message === 'valid') {
        onSuccess();
      } else {
        setError('Erreur lors de la création du compte');
      }
    } catch {
      setError('Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:24,position:'relative'}}>
          <img src={process.env.PUBLIC_URL + '/recat-logo-1024.png'} alt="Logo" style={{height:80}} />
          <div style={{position:'absolute',right:0,top:0}}>
            <LangToggle />
          </div>
        </div>
        <h2>{t.signupTitle}</h2>
        <input type="text" placeholder={t.signupUsername} value={username} onChange={e => setUsername(e.target.value)} required />
        <input type="email" placeholder={t.signupEmail} value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder={t.signupPassword} value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" disabled={loading}>{loading ? t.signupLoading : t.signupBtn}</button>
        {error && <div className="login-error">{error === 'Erreur lors de la création du compte' ? t.signupError : t.signupErrorNetwork}</div>}
      </form>
    </div>
  );
};

export default Signup;
